import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, Subject, throwError } from 'rxjs';
import { TildaPageDetails, TildaProject, TildaProjectPage } from '../models/tilda-project.model';
import { AlertService } from '../alert/alert.service';
import { AuthService, AuthType } from './auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TildaService {
    constructor(private http: HttpClient, private alertService: AlertService,
        private authService: AuthService) { }


    getTildaProjects(publickey: string, secretkey: string) {
        const baseUrl = 'https://api.tildacdn.info/v1/getprojectslist';
        const params = new HttpParams({
            fromObject: {
                publickey,
                secretkey,
            }
        });
        return this.http.get(baseUrl, {
            params
        }).pipe(
            catchError((err) => {
                this.alertService.error("ExdrCommon.ServerError");
                throw err;
            }),
            map(res => {
                return res;
            }),
        )

    }

    getProjectPages(publickey: string, secretkey: string, projectid: string): Observable<TildaProjectPage[]> {
        const baseUrl = 'https://api.tildacdn.info/v1/getpageslist';
        const params = new HttpParams({
            fromObject: {
                publickey,
                secretkey,
                projectid
            }
        });
        return this.http.get<TildaProjectPage[]>(baseUrl, {
            params
        }).pipe(
            catchError((err) => {
                this.alertService.error("ExdrCommon.ServerError");
                throw err;
            }),
            map(res => {
                return res['result'];
            }),
        )
    }

    getPageDetails(publickey: string, secretkey: string, pageid: string): Observable<TildaPageDetails> {
        const baseUrl = 'https://api.tildacdn.info/v1/getpageexport';
        const params = new HttpParams({
            fromObject: {
                publickey,
                secretkey,
                pageid
            }
        });
        return this.http.get<TildaPageDetails>(baseUrl, {
            params
        }).pipe(
            catchError((err) => {
                this.alertService.error("ExdrCommon.ServerError");
                throw err;
            }),
            map(res => {
                return res['result'];
            }),
        )
    }

    savePage(pageId: string, PublicKey: string, SecretKey: string) {
        const url = `${environment.apiHost}/api/pages/tilda/${pageId}`;
        const body = {
            PublicKey,
            SecretKey
        }

        const options = {
            headers: this.authService.buildAuthHeader(AuthType.Idenedi),
        };

        return this.http.put(url, body, options).pipe(
            catchError((err) => {
                this.alertService.error("ExdrCommon.ServerError");
                throw err;
            }),
        )
    }

}
